import type { FC } from 'react';
import React from 'react';

import type { TRatingDynamic } from '../../models';

interface IScoreDynamicIcon {
    dynamic: TRatingDynamic;
}
export const ScoreDynamicIcon: FC<IScoreDynamicIcon> = ({ dynamic }) => (
    <svg fill="none" height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
        {dynamic === 'increased' && (
            <>
                <circle cx="20" cy="20" fill="#0CC44D" r="20" />
                <path
                    d="M19 15.5V27H21V15.5L24.5 19L26 17.5L20 12L14 17.5L15.5 19L19 15.5Z"
                    fill="white"
                />
            </>
        )}
        {dynamic === 'decreased' && (
            <>
                <circle cx="20" cy="20" fill="#FF0002" r="20" />
                <path
                    d="M19 24.5V13H21V24.5L24.5 21L26 22.5L20 28L14 22.5L15.5 21L19 24.5Z"
                    fill="white"
                />
            </>
        )}
        {dynamic === 'unchanged' && (
            <>
                <circle cx="20" cy="20" fill="#DCDEE2" r="20" />
                <path d="M15 14H18V26H15V14Z" fill="white" />
                <path d="M22 14H25V26H22V14Z" fill="white" />
            </>
        )}
    </svg>
);
